import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Modal from "react-modal";
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'

require('styles/main.css')
Modal.setAppElement("#root");

// optional configuration
const options = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_CENTER,
  timeout: 6000,
  offset: '50px',
  // you can also just use 'scale'
  transition: transitions.SCALE,
  containerStyle: {
    borderRadius: '10px'
  }
}

const Root = () => (
  <AlertProvider template={AlertTemplate} {...options}>
    <App />
  </AlertProvider>
)

ReactDOM.render(
  <Root />,
  document.getElementById("root")
);
